<ng-container *ngIf="isUiVersion$ | async" [appHasAccess]="permissions">
  <button
    type="button"
    class="button button--small button--icon notification__btn"
    (click)="dropdownOnToggle()">
    <ng-container *ngTemplateOutlet="notificationIcon"></ng-container>
  </button>
  <ng-container [ngTemplateOutlet]="dropdown"></ng-container>
</ng-container>

<ng-template #notificationIcon>
  <ng-container [ngSwitch]="badgeHidden$ | async">
    <mat-icon
      *ngSwitchCase="false"
      matBadge="{{ unreadCount$ | async }}">notifications_active</mat-icon>
    <mat-icon *ngSwitchDefault>notifications</mat-icon>
  </ng-container>
</ng-template>

<ng-template #dropdown>
  <div
    class="notification__dropdown"
    [ngClass]="{ 'closed': !isOpen }"
    [clickOutside]="isOpen"
    (clickOutsideChange)="dropdownOnToggle()">
    <div class="notification__dropdown-header">
      <button
        type="button"
        class="button button--small button--icon notification__btn-close"
        (click)="dropdownOnToggle()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <ul class="notification__dropdown-list">
      <li *ngIf="isEmpty$ | async" class="notification__dropdown-item center">
        {{ 'NOTIFICATIONS.COMMON.NO_MESSAGES' | translate }}
      </li>
      <li
        *ngFor="let notify of (notifications$ | async)"
        class="notification__dropdown-item"
        [ngClass]="{ 'is-new': !(notify.read) }">
        <span class="notification__dropdown-item-header">
          <small class="notification__dropdown-item-date">{{notify.insertedAt | date : 'dd-MM-yyyy, HH:mm:ss' }}</small>
          <button type="button" class="notification__dropdown-item-remove" (click)="onRemoveNotify(notify)">
            <mat-icon>close</mat-icon>
          </button>
        </span>
        <span class="notification__dropdown-item-body">
          <ng-container *ngIf="notify.body">{{ notify.body }}</ng-container>
          <ng-container
            #itemRef
            *ngIf="notify.component"
            [dynamicHost]="notify.component"></ng-container>
        </span>
      </li>
    </ul>
  </div>
</ng-template>
